<template>
  <div class="content-item">
    <h2 class="heading">Church Email (Optional)</h2>
    <p class="text">This will be listed on the card</p>
    <div class="form-group">
      <input v-model="church_email" type="text" class="form-input" placeholder="example@example.com" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step5',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      church_email: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        church_email: this.church_email,
      });
    },
  },
};
</script>

<style lang="scss"></style>
